<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline"
									style="margin-left: 20px;">导出全部岗位</Button>
			</TableFuncs>
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="remark">
					<Input v-model="row.remark" clearable @on-blur="changeRamrk(row)"/>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
					<Button type="success" size="small" style="margin-right: 5px"
						@click="updateSorts(row)">排序</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		

		<Modal v-model="sortShow" title="排序" width="300">
			<Input v-model="sortIndex" type="number" maxlength="10" placeholder="请输入排序"></Input>
			<div slot="footer">
				<Button type="primary" @click="dateSetSure">确认</Button>
			</div>
		</Modal>
		
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition12'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				sortShow:false,
				sortIndex:undefined,
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					scene: undefined,
					attr: undefined,
					city: '',
					title: '',
					education: '',
					company: '',
					companyType: '',
					jobTag: '',
					recommendType: '',
					dataType: '',
					jobDesc: '',
					salary: 0,
					jobLimit: '',
					settleType: undefined,
					codeUrl: '',
					status: '1',
					sortIndex: 0,
					valid: '0',
					validConfig: {
						titleMsg: '',
						useAge: false,
						minAge: undefined,
						maxAge: undefined,
						ageMsg: "",

						useSex: false,
						sex: undefined,
						sexMsg: "",

						useEducation: false,
						education: undefined,
						educationMsg: "",

						useGraduate: false,
						graduate: undefined,
						graduateMsg: "",
					}
				},
				addRule: {

				},
				dateSetShow: false,
				dateSetId: undefined,
				recordDate: undefined,
				appChannelShow: false,
				appChannels: [],
			}
		},
		computed: {

			queryColumn() {
				return [{
						title: '岗位ID',
						width: 150,
						key: 'id',
						align: 'center'
					},
					{
						title: '岗位排序',
						width: 100,
						key: 'sortIndex',
						align: 'center'
					},
					{
						title: '数据来源',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.dataFrom;
							if (val == '2') {
								name = '自营'
							} else if(val == '3'){
								name = '青团'
							}
							return h('span', name)
						}
					},
					{
						title: '城市',
						key: 'city',
						align: 'center',
						width: 160,
					},
					{
						title: '工作场景',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.scene;
							if (val == '1') {
								name = '线上'
							} else if(val == '2'){
								name = '线下'
							}
							return h('span', name)
						}
					},
					{
						title: '三方岗位id',
						key: 'partTimeId',
						align: 'center',
						width: 260,
					},
					{
						title: '岗位名称',
						key: 'title',
						align: 'center',
						width: 260,
					},
					{
						title: '公司名称',
						key: 'company',
						align: 'center',
						width: 260,
					},
					{
						title: '最小年龄',
						key: 'minAge',
						align: 'center',
						width: 150,
					},
					{
						title: '最大年龄',
						key: 'maxAge',
						align: 'center',
						width: 150,
					},
					{
						title: '性别要求',
						key: 'gender',
						align: 'center',
						width: 160,
					},
					{
						title: '岗位类型',
						key: 'secondTagName',
						align: 'center',
						width: 150,
					},
					
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					},
					{
						title: '备注',
						slot: 'remark',
						width: 150,
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}


				]
			},
			appChannelCols() {
				return [{
						title: '渠道',
						width: 150,
						key: 'channel',
						align: 'center'
					}, {
						title: '网店',
						slot: 'onlineShop',
						width: 150,
						align: 'center'
					}, {
						title: '电商',
						slot: 'shop',
						width: 150,
						align: 'center'
					}, {
						title: '短视频带货',
						slot: 'videoShop',
						width: 150,
						align: 'center'
					}, {
						title: '短视频卖货',
						slot: 'videoSale',
						width: 150,
						align: 'center'
					}, {
						title: '线上兼职',
						slot: 'online',
						width: 150,
						align: 'center'
					}, {
						title: '主播',
						slot: 'liver',
						width: 150,
						align: 'center'
					}, {
						title: '瓷片区',
						slot: 'group',
						width: 150,
						align: 'center'
					}, {
						title: '自营区',
						slot: 'self',
						width: 150,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.jobQingPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			codeImgBack(response, file, fileList) {
				this.addForm.codeUrl = response.data.url
				this.codeImgs = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			addOrUpdateLight() {
				const that = this
				api.statistics
					.addOrEditJob(this.addForm)
					.then(res => {
						that.initAdd()
						that.addJobShow = false
						that.refreshData()
					})
					.then(() => {
						that.loading = false
					})
			},
			changeValid(state, data) {
				this.addForm.valid = state ? '1' : '0'
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateStatus(id, status) {
				const that = this
				api.statistics
					.updateQingJobStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(row) {
				const that = this
				api.statistics
					.jobDetail(row.id)
					.then(res => {
						const result = res.data || {}
						that.addForm = {
							...that.addForm,
							...result
						}
						if (result.validJson) {
							that.addForm.validConfig = JSON.parse(result.validJson)
						}
						that.codeImgs = [{
							name: result.codeUrl,
							url: result.codeUrl
						}];

						that.addJobShow = true
					})
			},

			initAdd() {
				this.codeImgs = [];
				this.addForm = {
					id: undefined,
					scene: undefined,
					attr: undefined,
					city: '',
					title: '',
					education: '',
					company: '',
					companyType: '',
					jobTag: '',
					recommendType: '',
					dataType: '',
					jobDesc: '',
					salary: 0,
					jobLimit: '',
					settleType: undefined,
					codeUrl: '',
					status: '1',
					sortIndex: 0,
					valid: '0',
					validConfig: {
						titleMsg: '',
						useAge: false,
						minAge: undefined,
						maxAge: undefined,
						ageMsg: "",

						useSex: false,
						sex: undefined,
						sexMsg: "",

						useEducation: false,
						education: undefined,
						educationMsg: "",

						useGraduate: false,
						graduate: undefined,
						graduateMsg: "",
					}
				}
			},
			dateSetSure() {
				const that = this
				const param = {
					"id": this.dateSetId,
					"sortIndex": this.sortIndex
				}
				api.statistics
					.qingJobSort(param)
					.then(res => {
						that.sortShow = false
						that.refreshData()
					})
			},
			appChannelConfigShow() {
				const queryParams = {
					page: 1,
					limit: 100
				}
				//获取全部应用市场
				api.statistics
					.getStorePage(queryParams)
					.then(res => {
						const result = res.data || {}
						const allApp = result.records
						//获取渠道配置
						api.statistics
							.getAppChannelSwitch()
							.then(res => {
								let result = res.data || []
								let appCodes = []
								for (var i = 0; i < result.length; i++) {
									appCodes[i] = result[i].channel
								}
								allApp.forEach(function(obj) {
									if (appCodes.indexOf(obj.storeCode) < 0) {
										result.push({
											channel: obj.storeCode,
											onlineShop: true,
											shop: true,
											videoShop: true,
											online: true,
											liver: true,
											group: true,
											self: true,
											videoSale: true,
										})
									}
								});
								this.appChannels = result
								this.appChannelShow = true
							})
					})
					.catch(err => {
						this.$Message.error('获取应用市场列表失败: ' + err.message)
					})
			},
			appChannelConfig() {
				api.statistics
					.appChannelSwitchConfig({
						appChannelSwitches: this.appChannels
					})
					.then(res => {
						this.appChannelShow = false
					})
			},
			//导出数据
			exportExcel() {
				const that = this
				const queryParams = {
					page: 1,
					limit: 10,
					...this.queryParams
				}
				api.statistics
					.exportQingJob(queryParams)
					.then(res => {
						that.util.excel(res, "岗位数据")
					})
			},
			updateSorts(row){
				this.sortShow=true,
				this.dateSetId = row.id
			},
			changeRamrk(row){
				const that = this
				api.statistics
					.updateQingJobRemark({
						'id': row.id,
						remark: row.remark
					})
					.then(res => {
						that.$Message.success('Success!');
						
					})
			}
		}

	}
</script>